<template>
  <div class="vacancy-video-record">
    <videointerview
      :id="id"
      :video_player_src="blob || video_player_src"
      :is_retake="is_retake"
      :disable_save_video="disable_save_video"
      @complete_recording="complete_recording"
      @startRecording="startRecording"
      @retakeTestVideo="retakeTestVideo"
      @save="save"
    />
  </div>
</template>

<script>
import Videointerview from './Videointerview.vue';

export default {
  name: 'vacancy_video_record',

  components: {
    Videointerview
  },

  props: ['video_player_src', 'id', 'blob', 'is_retake', 'disable_save_video'],

  data() {
    return {
      isRecordingTestComplete: false
    };
  },

  methods: {
    complete_recording(val) {
      this.$emit('complete_recording', val);
    },

    save() {
      this.$emit('save');
    },

    retakeTestVideo() {
      this.$emit('retakeTestVideo');
    },

    startRecording() {
      this.$emit('startRecording');
    }
  }
};
</script>

<style lang="scss" scoped>
.vacancy-video-record {
  width: 100%;
}
</style>
